import { createSelector } from 'reselect'
import getGroupPaymentDepositAmount from './getGroupPaymentDepositAmount'

// Deposit (share + lead-only items) — credit/gift and fee-exempt items (LuxPlus) are subtracted
// in getMerchantFeeAmount to avoid a circular import, as for payment schedules.
const getGroupPaymentMerchantFeeEligibleAmount = createSelector(
  getGroupPaymentDepositAmount,
  (depositAmount): number => depositAmount,
)

export default getGroupPaymentMerchantFeeEligibleAmount
